export const HeaderTheme = {
  transparent: 'transparent',
  white: 'white',
  blue: 'blue',
} as const;

export const HeaderSize = {
  default: 'default',
  full: 'full',
} as const;

export type HeaderThemeType = keyof typeof HeaderTheme;
